"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = exports.SingleInput = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var utils_1 = require("../../utils");

var Block_1 = require("../Block");

var Text_1 = require("../Text");

var InputIcon_1 = require("./InputIcon");

var InputLabel_1 = require("./InputLabel");

var InputTooltip_1 = require("./InputTooltip");

exports.SingleInput = styled_components_1.default.input(function (_a) {
  var error = _a.error,
      type = _a.type,
      height = _a.height,
      styles = _a.styles,
      hasValue = _a.hasValue,
      disabled = _a.disabled,
      leftIcon = _a.leftIcon,
      rightIcon = _a.rightIcon,
      floatingLabel = _a.floatingLabel;
  var fontColor = disabled ? styles.disabledColor : styles.color;
  var backgroundColor = styles.backgroundColor || 'white';
  var floatingTopOffset = styles.labelSize + 4;
  return styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    box-sizing: border-box;\n    width: 100%;\n    height: ", "px;\n    line-height: ", "px;\n    padding: 0 8px;\n    background-color: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    box-shadow: ", ";\n    outline: 0;\n    font-size: ", "px;\n    transition: border-color 250ms, box-shadow 250ms, padding 250ms;\n\n    &:focus {\n      border-color: ", ";\n      box-shadow: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    box-sizing: border-box;\n    width: 100%;\n    height: ", "px;\n    line-height: ", "px;\n    padding: 0 8px;\n    background-color: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    border-radius: ", "px;\n    box-shadow: ", ";\n    outline: 0;\n    font-size: ", "px;\n    transition: border-color 250ms, box-shadow 250ms, padding 250ms;\n\n    &:focus {\n      border-color: ", ";\n      box-shadow: ", ";\n    }\n\n    ", "\n\n    ", "\n\n    ", "\n  "])), height, height, backgroundColor, fontColor, styles.borderColor, styles.borderRadius, error ? styles.shadowErrorColor : styles.shadowColor, styles.fontSize, styles.focusBorderColor, styles.focusShadowColor, leftIcon && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        padding-left: ", "px;\n      "], ["\n        padding-left: ", "px;\n      "])), styles.fontSize * 2), rightIcon && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        padding-right: ", "px;\n      "], ["\n        padding-right: ", "px;\n      "])), styles.fontSize * 2), floatingLabel && styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n        ::placeholder {\n          opacity: 0;\n        }\n\n        ", "\n\n        &:focus {\n          padding-top: ", "px;\n          border-color: ", ";\n        }\n\n        ", "\n\n        ", "\n      "], ["\n        ::placeholder {\n          opacity: 0;\n        }\n\n        ", "\n\n        &:focus {\n          padding-top: ", "px;\n          border-color: ", ";\n        }\n\n        ", "\n\n        ", "\n      "])), type === 'date' && "\n          color: " + (hasValue ? fontColor : backgroundColor) + ";\n          &:focus {\n            color: " + fontColor + ";\n          }\n        ", floatingTopOffset, styles.focusBorderColor, hasValue && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            padding-top: ", "px;\n            border-color: ", ";\n          "], ["\n            padding-top: ", "px;\n            border-color: ", ";\n          "])), floatingTopOffset, styles.borderColor), leftIcon && styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            padding-left: 8px;\n          "], ["\n            padding-left: 8px;\n          "])))));
});
var StyledTextArea = styled_components_1.default.textarea(function (_a) {
  var theme = _a.theme,
      error = _a.error,
      disabled = _a.disabled,
      floatingLabel = _a.floatingLabel,
      _b = _a.styles,
      fontSize = _b.fontSize,
      backgroundColor = _b.backgroundColor,
      borderRadius = _b.borderRadius,
      disabledColor = _b.disabledColor,
      borderColor = _b.borderColor,
      color = _b.color;
  return styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-family: inherit;\n    border: 1px solid ", ";\n    background-color: ", ";\n    color: ", ";\n    box-shadow: ", ";\n    font-size: ", "px;\n    border-radius: ", "px;\n    outline: 0;\n    padding-top: 8px;\n    padding-left: 8px;\n    width: 100%;\n    height: 100px;\n\n    ", "\n  "], ["\n    font-family: inherit;\n    border: 1px solid ", ";\n    background-color: ", ";\n    color: ", ";\n    box-shadow: ", ";\n    font-size: ", "px;\n    border-radius: ", "px;\n    outline: 0;\n    padding-top: 8px;\n    padding-left: 8px;\n    width: 100%;\n    height: 100px;\n\n    ", "\n  "])), borderColor, backgroundColor, disabled ? disabledColor : color, error ? theme.shadows.error : theme.shadows.greyLight, fontSize, borderRadius, floatingLabel && styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        padding-top: 24px;\n        padding-left: 9px;\n\n        ::placeholder {\n          opacity: 0;\n        }\n      "], ["\n        padding-top: 24px;\n        padding-left: 9px;\n\n        ::placeholder {\n          opacity: 0;\n        }\n      "]))));
});
var StyledBlock = styled_components_1.default(Block_1.Block)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (p) {
  return p.fullWidth ? "width: 100%" : '';
});

function Input(_a) {
  var type = _a.type,
      name = _a.name,
      className = _a.className,
      placeholder = _a.placeholder,
      onChange = _a.onChange,
      onBlur = _a.onBlur,
      onFocus = _a.onFocus,
      onKeyDown = _a.onKeyDown,
      onKeyUp = _a.onKeyUp,
      _b = _a.size,
      size = _b === void 0 ? 'default' : _b,
      _c = _a.value,
      value = _c === void 0 ? '' : _c,
      error = _a.error,
      label = _a.label,
      required = _a.required,
      disabled = _a.disabled,
      rightIcon = _a.rightIcon,
      rightIconExtras = _a.rightIconProps,
      leftIcon = _a.leftIcon,
      leftIconExtras = _a.leftIconProps,
      variant = _a.variant,
      _d = _a.floatingLabel,
      floatingLabel = _d === void 0 ? true : _d,
      ariaLabel = _a.ariaLabel,
      fullWidth = _a.fullWidth,
      tooltip = _a.tooltip,
      tooltipProps = _a.tooltipProps,
      rest = __rest(_a, ["type", "name", "className", "placeholder", "onChange", "onBlur", "onFocus", "onKeyDown", "onKeyUp", "size", "value", "error", "label", "required", "disabled", "rightIcon", "rightIconProps", "leftIcon", "leftIconProps", "variant", "floatingLabel", "ariaLabel", "fullWidth", "tooltip", "tooltipProps"]);

  var _e = React.useState(false),
      isFocused = _e[0],
      setFocus = _e[1];

  var _f = React.useState(false),
      isFloating = _f[0],
      setFloating = _f[1];

  var inputRef = React.createRef();
  var textAreaRef = React.createRef();
  var hasValue = value != null && value !== '';

  var handleFloating = function handleFloating() {
    setFloating(hasValue || isFocused);
  };

  var handleChange = function handleChange(e) {
    if (typeof onChange === 'function') {
      onChange(e);
    }
  };

  var handleFocus = function handleFocus(e) {
    setFocus(true);

    if (inputRef.current) {
      inputRef.current.focus();
    }

    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }

    if (typeof onFocus === 'function') {
      onFocus(e);
    }
  };

  var handleBlur = function handleBlur(e) {
    setFocus(false);

    if (inputRef.current) {
      inputRef.current.blur();
    }

    if (textAreaRef.current) {
      textAreaRef.current.blur();
    }

    if (typeof onBlur === 'function') {
      onBlur(e);
    }
  };

  var handleKeyUp = function handleKeyUp(e) {
    if (typeof onKeyUp === 'function') {
      onKeyUp(e);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (typeof onKeyDown === 'function') {
      onKeyDown(e);
    }
  };

  var handleLabelClick = function handleLabelClick(e) {
    if (floatingLabel && !disabled) {
      handleFocus(e);
    }
  };

  React.useEffect(function () {
    handleFloating();
  }, [hasValue, isFocused]);
  var theme = styled_components_1.useTheme();
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'Input', variant, size);
  var statusProps = {
    hasValue: hasValue,
    floatingLabel: floatingLabel,
    error: error,
    disabled: disabled,
    isFloating: isFloating
  };
  var eventProps = {
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp
  };

  var inputProps = __assign(__assign(__assign({
    placeholder: placeholder ? placeholder : label,
    value: value,
    styles: themeStyles,
    name: name,
    leftIcon: leftIcon,
    rightIcon: rightIcon
  }, statusProps), eventProps), rest);

  var iconProps = __assign(__assign({
    floatingLabel: floatingLabel
  }, statusProps), themeStyles);

  var leftIconProps = __assign(__assign({
    icon: leftIcon
  }, iconProps), leftIconExtras);

  var rightIconProps = __assign(__assign({
    icon: rightIcon,
    isRight: true
  }, iconProps), rightIconExtras);

  var Label = label ? React.createElement(InputLabel_1.InputLabel, __assign({
    htmlFor: name,
    inputType: type,
    labelSize: themeStyles.labelSize,
    onClick: handleLabelClick,
    hasLeftIcon: !!leftIcon,
    fontSize: themeStyles.fontSize,
    "aria-label": ariaLabel || name,
    variant: variant
  }, statusProps), React.createElement(React.Fragment, null, label, required && React.createElement(Text_1.Text, {
    color: "red"
  }, " *"))) : null;
  var LeftIcon = leftIcon ? React.createElement(InputIcon_1.InputIcon, __assign({}, leftIconProps)) : null;
  var RightIcon = rightIcon ? React.createElement(InputIcon_1.InputIcon, __assign({}, rightIconProps)) : null;
  var TooltipComponent = tooltip ? React.createElement(InputTooltip_1.InputTooltip, __assign({}, tooltipProps), tooltip) : null;
  var Error = error ? React.createElement(Text_1.Text, {
    color: themeStyles.errorTextColor,
    className: "error-text",
    fontSize: "0.7rem",
    mt: "8px",
    ml: "8px",
    position: "absolute",
    left: 0,
    top: "100%"
  }, error) : null;
  var Input = type === 'textarea' ? React.createElement(StyledTextArea, __assign({
    ref: textAreaRef
  }, inputProps)) : React.createElement(exports.SingleInput, __assign({
    type: type,
    ref: inputRef,
    height: themeStyles.height
  }, inputProps));
  return React.createElement(StyledBlock, {
    className: className,
    mb: error && 16,
    transition: "margin-bottom 150ms",
    fullWidth: fullWidth
  }, !floatingLabel && Label, React.createElement(Block_1.Block, {
    position: "relative"
  }, floatingLabel && Label, LeftIcon, Input, RightIcon, TooltipComponent, Error));
}

exports.Input = Input;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;